import { useLayoutEffect, useState } from "react"

export function useBreakpoints() {
    const [size, setSize] = useState(window.innerWidth)

    useLayoutEffect(() => {
        const updateSize = () => setSize(window.innerWidth)
        window.addEventListener('resize', updateSize)
        return () => window.removeEventListener('resize', updateSize)
    }, [])

    return {
        sm: size > 640,
        md: size > 768,
        lg: size > 1024,
        xl: size > 1280,
        xxl: size > 1536,
        isMobile: size < 768
    }
}